/**
 * Reads all streaming data at once.
 * @module
 * @deprecated Use `@ayonli/jsext/reader` module instead.
 */
import { readAsArray } from "./reader.ts";
/**
 * @deprecated Use {@link readAsArray} from `@ayonli/jsext/reader` instead.
 */
const readAll = readAsArray;
export default readAll;
//# sourceMappingURL=readAll.js.map